module.exports = __webpack_public_path__ + "static/img/8.705ea6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/8.png
// module id = 8naU
// module chunks = 1